module.exports = __webpack_public_path__ + "img/RAFullLogo.25798499.png";